import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginIndexComponent } from "./pages/index/index.component";

const routes: Routes = [{ path: "", component: LoginIndexComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [],
  declarations: [],
})
export class LoginRoutingModule {}
